import { AxiosRequestConfig, AxiosError, AxiosResponse } from "axios";
import Api from "./Api";
import { DadosVeiculoInfoCarDTO } from './assistencia24h/DadosVeiculoInfoCarDTO';
import { consultaVeiculoApiConfig } from './config';

export class ConsultaVeiculoApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  obterInformacoesVeiculo(placa: string): Promise<DadosVeiculoInfoCarDTO>{    
    return this.get<any>(
      `/consultaveiculo/${placa}`
    )
    .then((registered: AxiosResponse) => {
      const { data } = registered;
      return data;
    })
    .catch((error: AxiosError) => {
      console.error(error);
      throw new Error("Falha ao obter dados do veículo");
    });

  }

  obterInformacoesVeiculoChassi(chassi: string): Promise<DadosVeiculoInfoCarDTO>{
    return this.get<any>(
      `/consultaveiculo/chassi/${chassi}`
    )
    .then((registered: AxiosResponse) => {
      const { data } = registered;
      return data;
    })
    .catch((error: AxiosError) => {
      console.error(error);
      throw new Error("Falha ao obter dados do veículo");
    });
  }
}

export const consultaVeiculoApi = new ConsultaVeiculoApi(
  consultaVeiculoApiConfig
);
